/* unplugin-vue-components disabled */import script from "./iosDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./iosDetail.vue?vue&type=script&setup=true&lang=ts"

import "./iosDetail.vue?vue&type=style&index=0&id=589c4dc3&lang=less&scoped=true"
import "./iosDetail.vue?vue&type=style&index=1&id=589c4dc3&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589c4dc3"]])

export default __exports__